var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrisConnectBamboo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8dc440;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.75,319.4A41.51,41.51,0,0,1,273,277.65c0-23.93,16.15-43.57,42.2-43.57s41.4,21.07,41.4,43.12c0,24-16.25,42.2-41.81,42.2M316.57,217c-20.87,0-32.05,7.16-39.9,14.95l-2.14,2.24V164.24h-18V278.68c0,35.21,27.13,57.15,58.26,57.15,34.28,0,60.24-26.39,60.24-60.3C375,244,347.93,217,316.57,217"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.91,252c-1.32-1.9-4.82-6.85-9.63-13.07a262.88,262.88,0,0,0-20-23.26c-5.81-5.87-11.85-11.17-17.61-14.72-3.78-2.35-7.66-4.51-11.49-6.5-17.31-9-34.09-14.44-40.52-16A101.56,101.56,0,0,0,125,175.9s25.07,21.18,35.83,34.66S184.28,237,196.4,241.91s16.33,6.37,25.86,7.8c8.22,1.25,18.23,3.13,18.23,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.26,238.4s-24.32-45.62-45.65-73.79c-2.26-3,18,9.87,23.4,15.61,15.84,16.72,17.5,26.07,23.12,42.3s9.44,30.87,9.44,30.87Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrisConnectBamboo);
export default __webpack_public_path__ + "static/media/HRIS-connect-bamboo.3a2932b9d79f5344df2a3fc336c0fded.svg";
export { ForwardRef as ReactComponent };